export default __webpack_public_path__ + "static/media/interior (8).e8fa2d22.jpg";